var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{staticClass:"table-lg table-nowrap card-table",attrs:{"striped":"","items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }